import { Engine } from "./Core/Engine";
import { HslColorManager } from "./Utils/HslColorManager";
import { RgbColorManager } from "./Utils/RgbColorManager";
import { addColorManager } from "./Utils/ColorUtils";
export function init() {
  var rgbColorManager = new RgbColorManager(),
      hslColorManager = new HslColorManager();
  addColorManager(rgbColorManager);
  addColorManager(hslColorManager);
  var engine = new Engine();
  engine.init();
  return engine;
}